import { render } from "./GlobalSearch.vue?vue&type=template&id=63010c14"
import script from "./GlobalSearch.vue?vue&type=script&lang=js"
export * from "./GlobalSearch.vue?vue&type=script&lang=js"

import "./GlobalSearch.vue?vue&type=style&index=0&id=63010c14&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__